

































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { QrAlipayGame, QrWechatGame, PayStatus, BalancePay } from "@/req/pay";
import { getUserInfo } from "@/req/user";

@Component
export default class Home extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public boxName;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public imgUrl;
  public QRCode: any;
  public lose = false; // 遮罩
  public qrCodeLoading = false;
  public qrCodeState = false;
  public timer: any = null; // 定时器名称
  public checkTimer: any = null; // 定时器名称
  public timeID: any = null;
  public ms = 500;
  public confirmFn: any = null;
  @Watch("boxNameObj", { immediate: true, deep: true })
  public boxNameChange(newL, oldL) {
    // this.qrCodeState = false;
    this.qrCodeState = !this.qrCodeState;
    if (JSON.stringify(newL) !== JSON.stringify(oldL) && this.boxName.accountStatus) {
      this.ms = 500;
      clearTimeout(this.timeID);
      this.timeID = setTimeout(() => {
        if (this.boxName.activeWay !== 2 && this.boxName.activeWay !== 3) {
          this.qrScan();
        } else {
          this.cleanTimer();
          this.qrCodeState = true;
        }
      }, this.ms);
    }
  }
/*   public mounted() {
    this.qrScan();
  } */
  get boxNameObj() {
    return JSON.parse(JSON.stringify(this.boxName));
  }
  // 获取二维码url
  public async qrScan() {
    this.qrCodeLoading = true;
    this.cleanTimer();
    this.qrCodeState = true;
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      uid: this.boxName.uid,
      box_game_id: this.boxName.boxGameId,
      serverid: this.boxName.serverid,
      server_name: this.boxName.serverName,
      roleid: this.boxName.roleid,
      role_name: this.boxName.roleName,
      pay_amount: this.boxName.payMoney * 100,
      props_name: `${this.boxName.gameName}${this.boxName.payKind.name}${this.boxName.payMoney}`,
      balance_id: this.boxName.payKind.itemid,
      grade_id: this.boxName.grade_id
    };
    let res;
    if (this.boxName.activeWay === 0) {
      res = await QrAlipayGame(obj);
    } else if (this.boxName.activeWay === 1) {
      res = await QrWechatGame(obj);
    } else if (this.boxName.activeWay === 2 || this.boxName.activeWay === 3) {
      this.qrCodeState = false;
      return false;
    } else {
      return false;
    }
    if (res.code === 200) {
      this.qrCode(res.data);
    }
    this.checkTimer = setTimeout(() => {
      this.cleanTimer();
      this.lose = true;
    }, 1000 * 60 * 10);
  }
  // 二维码生成
  public qrCode(data: any) {
    if (
      (document as any).getElementById("qrcode") != null &&
      (document as any).getElementById("qrcode") != undefined
    ) {
      (document as any).getElementById("qrcode").innerHTML = "";
      const qrcode = new this.QRCode("qrcode", {
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        typeNumber: 4,
      });
      qrcode.clear();
      qrcode.makeCode(data.url);
      this.checkTraining(data.pay_order);
      this.qrCodeLoading = false;
    }
  }
  // 查询充值状态轮询
  public checkTraining(val) {
    const self = this;
    let num = 0;
    self.timer = setInterval(() => {
      num++;
      this.UserPay(val);
      if (num == 60) {
        this.cleanTimer();
        this.checkTraining(val);
      }
    }, 2000);
  }
  // 获取充值查询接口
  public async UserPay(val) {
    const res = await PayStatus({
      token: this.$fn.cookies.getToken(),
      pay_order: val,
    });
    if (res.code == 200) {
      this.cleanTimer();
      this.getUserInfo();
      this.$Modal.success({
        title: "充值成功",
        onOk: () => {
          this.boxName.activeWay = null;
        },
      });
    }
  }
  // 余额支付
  public async payment(num) {
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      uid: this.boxName.uid,
      box_game_id: this.boxName.boxGameId,
      serverid: this.boxName.serverid,
      server_name: this.boxName.serverName,
      roleid: this.boxName.roleid,
      role_name: this.boxName.roleName,
      pay_amount: this.boxName.payMoney * 100,
      props_name: `${this.boxName.gameName}${this.boxName.payKind.name}${this.boxName.payMoney}`,
      balance_id: this.boxName.payKind.itemid,
      pay_way: num,
      grade_id: this.boxName.grade_id
    };
    const res = await BalancePay(obj);
    if (res.code == 200) {
      this.getUserInfo();
      this.$Modal.success({
        title: res.msg,
        onOk: () => {
          this.boxName.activeWay = null;
        },
      });
    } else {
      this.$Modal.error({
        title: "支付失败",
        content: res.msg
      });
    }
  }
  // 获取用户信息
  public async getUserInfo() {
    const res = await getUserInfo({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code === 200) {
      this.$store.dispatch("user/authInfo", res.data.userinfo);
    }
  }
  // 页面销毁
  public beforeDestroy() {
    this.cleanTimer();
  }
  // 定时器清除
  public cleanTimer() {
    clearInterval(this.timer);
    clearTimeout(this.checkTimer);
    this.timer = null;
    this.checkTimer = null;
  }
  public payBoxChange() {
    this.$router.push({ path: "/wallet/boxTopUp" });
  }
}
